import type { SVGProps } from 'react'

interface TrendingUpIconProps extends SVGProps<SVGSVGElement> {}

export function TrendingUpIcon(props: TrendingUpIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="m136-240-56-56 296-298 160 160 208-206H640v-80h240v240h-80v-104L536-320 376-480 136-240Z" />
    </svg>
  )
}
